// @ts-check
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from 'use-analytics';

export default function TrackRoutes({ children = null }) {
  usePageViews();
  return children;
}

function usePageViews() {
  const location = useLocation();
  const { page } = useAnalytics();
  React.useEffect(() => {
    page();
  }, [location.pathname, page]);
}
